import { cn } from "@/lib/utils";

export function Skel({ className }) {
    return <div className={cn("skeleton rounded-lg", className)} />;
}

export function CardSkeleton() {
    return (
        <div className="rounded-2xl border border-nm-line bg-nm-surface p-5">
            <div className="flex items-center gap-3">
                <Skel className="h-10 w-10 rounded-full" />
                <div className="flex-1 space-y-2">
                    <Skel className="h-4 w-1/2" />
                    <Skel className="h-3 w-1/3" />
                </div>
            </div>
            <Skel className="mt-4 h-3 w-full" />
            <Skel className="mt-2 h-3 w-2/3" />
        </div>
    );
}

export function ListSkeleton({ rows = 5 }) {
    return (
        <div className="space-y-3">
            {Array.from({ length: rows }).map((_, i) => (
                <CardSkeleton key={i} />
            ))}
        </div>
    );
}

export function StatSkeleton() {
    return (
        <div className="rounded-2xl border border-nm-line bg-nm-surface p-5">
            <Skel className="h-3 w-20" />
            <Skel className="mt-3 h-8 w-12" />
        </div>
    );
}
